import { render, staticRenderFns } from "./newindex.vue?vue&type=template&id=1d84e700&scoped=true&"
import script from "./newindex.vue?vue&type=script&lang=js&"
export * from "./newindex.vue?vue&type=script&lang=js&"
import style0 from "./newindex.vue?vue&type=style&index=0&id=1d84e700&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d84e700",
  null
  
)

export default component.exports